import React from 'react';
type PullQuoteProps = {
  children: React.ReactNode;
  author: string;
  role: string;
  className?: string;
};

/** One large editorial quote, shared by the home page and the case studies. */
export function PullQuote({
  children,
  author,
  role,
  className = ''
}: PullQuoteProps) {
  return <figure className={`border-t border-line pt-8 ${className}`} data-id="element-261" data-mp="2udxh84qdcndr">
      <blockquote className="t-quote measure text-ink" data-id="element-262" data-mp="2ufqmpgp8x1k6">{children}</blockquote>
      <figcaption className="t-label mt-8 text-subtle" data-id="element-263" data-mp="2pfm7rv3zkew2">
        <span className="text-ink" data-id="element-264" data-mp="2kncjskmflowf">{author}</span>
        <span aria-hidden="true" data-id="element-265" data-mp="2klhxp2zfbqqr"> — </span>
        {role}
      </figcaption>
    </figure>;
}